import { useState } from 'react'
import { CloseRounded } from '@mui/icons-material'
import { Box, Button, IconButton, Modal, Stack, Typography } from '@mui/material'
import Step1 from '../../assets/pt-interactive/step1_en.png'
import Step2 from '../../assets/pt-interactive/step2_en.png'
import Step3 from '../../assets/pt-interactive/step3_en.png'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
}

const PTModalEN = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const [curPage, setCurPage] = useState(1)

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ zIndex: 2000 }}
    >
      <Box sx={style}>
        <IconButton sx={{ position: 'absolute', right: 10, top: 10 }} onClick={onClose}>
          <CloseRounded />
        </IconButton>
        <Typography id="modal-modal-title" variant="h3" component="h2" color="primary">
          Introduction to the Information System
        </Typography>
        {curPage === 1 && (
          <>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              With the information system, you can easily comply with the information obligation of
              the EU Pay Transparency Directive (2023/970). You will receive an overview of the pay
              of women and men employed in the company for each equal or equivalent activity. This
              system can also be used to provide information on pay for future employees.
            </Typography>
            <Typography sx={{ mt: 2 }}>
              All results are made available as PDF or CSV files.
            </Typography>
            <Typography color="primary" sx={{ mt: 2, fontWeight: 'bold' }}>
              How to use the system:
            </Typography>
            <Typography sx={{ mt: 2, fontWeight: 'bold' }}>Step 1</Typography>
            <Typography>
              Select the relevant activity in your company and enter the current gross annual basic
              salary as the full-time equivalent of the employee(s).
            </Typography>
            <Typography>
              It is also possible to enter the planned remuneration of a person employed in the
              future.
            </Typography>
            <Stack
              sx={{
                width: '100%',
                height: 250,
                alignItems: 'center',
                justifyContent: 'center',
                mt: 2,
              }}
            >
              <img src={Step1} height={250} alt="step" />
            </Stack>
          </>
        )}
        {curPage === 2 && (
          <>
            <Typography sx={{ mt: 2, fontWeight: 'bold' }}>Step 2</Typography>
            <Typography>
              The average pay by gender in the corresponding group of equal or equivalent work is
              now displayed.
            </Typography>
            <Typography sx={{ mt: 2 }}>
              The graph shows you how your pay compares to that of other employees in the same
              group.
            </Typography>
            <Stack
              sx={{
                width: '100%',
                height: 425,
                alignItems: 'center',
                justifyContent: 'center',
                mt: 2,
              }}
            >
              <img src={Step2} height={425} alt="step" />
            </Stack>
          </>
        )}
        {curPage === 3 && (
          <>
            <Typography sx={{ mt: 2, fontWeight: 'bold' }}>Step 3</Typography>
            <Typography>
              Select the information you want to export either as a PDF or as CSV.
            </Typography>
            <Typography sx={{ mt: 2 }}>Diagrams are only exported in the PDF format.</Typography>
            <Stack
              sx={{
                width: '100%',
                height: 400,
                alignItems: 'center',
                justifyContent: 'center',
                mt: 2,
              }}
            >
              <img src={Step3} height={400} alt="step" />
            </Stack>
          </>
        )}
        <Stack direction="row" justifyContent="flex-end" mt={4} alignItems="center">
          {curPage > 1 && <Button onClick={() => setCurPage(curPage - 1)}>Back</Button>}
          {curPage < 3 && (
            <Button variant="contained" sx={{ ml: 2 }} onClick={() => setCurPage(curPage + 1)}>
              Next
            </Button>
          )}
          {curPage === 3 && (
            <Button variant="contained" sx={{ ml: 2 }} onClick={onClose}>
              Start
            </Button>
          )}
        </Stack>
      </Box>
    </Modal>
  )
}

export default PTModalEN
